import { render, staticRenderFns } from "./DispatchTaskModal.vue?vue&type=template&id=00c0a018&scoped=true&lang=pug"
import script from "./DispatchTaskModal.vue?vue&type=script&lang=js"
export * from "./DispatchTaskModal.vue?vue&type=script&lang=js"
import style0 from "./DispatchTaskModal.vue?vue&type=style&index=0&id=00c0a018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c0a018",
  null
  
)

export default component.exports